import { render, staticRenderFns } from "./ProductionTable.vue?vue&type=template&id=0d35ede4&"
import script from "./ProductionTable.vue?vue&type=script&lang=js&"
export * from "./ProductionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports